import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { from, lastValueFrom } from "rxjs";
import { Utilities } from "src/app/models/utilities";
import { AppCoreService } from "src/app/services/app-core.service";
import { GeoService } from "src/app/services/geo.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { ProductService } from "src/app/services/products.service";
import { VendorService } from "src/app/services/vendor.service";
import { ZoneService } from "src/app/services/zone.service";

@Component({
    selector: 'app-ratedetails',
    templateUrl: './ratedetails.component.html',
    styleUrls: ['./ratedetails.component.scss'],
})

export class RateDetailsComponent implements OnInit, AfterViewInit {
    @Input() data: any;
    rateDetailsForm: FormGroup;
    isFormSubmitted = false;
    Id: number;
    countryList: [];
    originStateList: [];
    destinationStateList: [];
    originCityList: [];
    destinationCityList: [];
    countryCode: any;
    productList: any;
    vendorList: any;
    serviceList: any;
    rateId: any;
    categoryList = [
        { category: 'Initial' },
        { category: 'Additional' },
        { category: 'Plus' },
        { category: 'Upto' }
    ]
    zoneList: any[];
    useEnterKey: any;

    constructor(
        private formBuilder: FormBuilder,
        private rateUploadService: RateUploadService,
        private ngxLoaderService: NgxUiLoaderService,
        private geoService: GeoService,
        private vendorService: VendorService,
        private zoneService: ZoneService,
        private productService: ProductService,
        public activeModal: NgbActiveModal,
        private appCoreService: AppCoreService,
        private utilities: Utilities,
    ) { }

    async ngOnInit() {
        this.rateDetailsForm = this.formBuilder.group({
            ddlOriginCountry: [],
            ddlOriginState: [],
            ddlOriginCity: [],
            ddlDestinationCountry: [],
            ddlDestinationState: [],
            ddlDestinationCity: [],

            ddlProduct: [],
            ddlVendor: [],
            ddlService: [],
            ddlZone: [],
            // txtMinWeight: [null, Validators.required],
            // txtMaxWeight: [null, Validators.required],
            txtWeight: [null, Validators.required],
            txtRate: [null, Validators.required],
            ddlCategory: []
        });
        await lastValueFrom(from(this.getAllZones()));
        await lastValueFrom(from(this.getAllVendors()));
        await lastValueFrom(from(this.getAllProducts()));
        await lastValueFrom(from(this.bindCountries()));
        this.bindFields(this.data);

        // const userData = this.appCoreService.GetUserData();
        // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.rateDetailsForm) : null;
    }

    async bindFields(cell: any) {
        if (cell) {
            this.ngxLoaderService.start();
            this.Id = cell?.id;
            let originstate: any, destinationstate: any;
            const origincountry: any = this.countryList.filter((item: any) => item.code == cell.origincountrycode);
            const destinationcountry: any = this.countryList.filter((item: any) => item.code == cell.destinationcountrycode);
            this.rateDetailsForm.controls.ddlProduct.setValue(cell.productcode);
            this.rateDetailsForm.controls.ddlVendor.setValue(cell.vendorcode);
            this.rateDetailsForm.controls.ddlZone.setValue(cell.zonecode);
            this.rateDetailsForm.controls.txtWeight.setValue(cell.weight);
            // this.rateDetailsForm.controls.txtMinWeight.setValue(cell.minweight);
            // this.rateDetailsForm.controls.txtMaxWeight.setValue(cell.maxweight);
            this.rateDetailsForm.controls.txtRate.setValue(cell.rate);
            this.rateDetailsForm.controls.ddlCategory.setValue(cell.ratetype);
            this.getAllVendorServices(cell.vendorcode);
            this.rateDetailsForm.get('ddlOriginCountry').setValue(cell.origincountrycode);
            this.rateDetailsForm.get('ddlDestinationCountry').setValue(cell.destinationcountrycode);
      
            await lastValueFrom(from(this.bindStatesByCountry(origincountry?.[0]?.isocode, 'origin')));
            originstate = this.originStateList?.filter((item: any) => item.code == cell.originstatecode);
            await lastValueFrom(from(this.bindCitiesByState(originstate?.[0]?.isocode, 'origin')));
            this.rateDetailsForm.get('ddlOriginState').setValue(cell.originstatecode);
            this.rateDetailsForm.get('ddlOriginCity').setValue(cell.origincitycode);
            
            await lastValueFrom(from(this.bindStatesByCountry(destinationcountry?.[0]?.isocode)));
            destinationstate = this.destinationStateList?.filter((item: any) => item.code == cell.destinationstatecode);
            await lastValueFrom(from(this.bindCitiesByState(destinationstate?.[0]?.isocode)));
            this.rateDetailsForm.get('ddlDestinationState').setValue(cell.destinationstatecode);
            this.rateDetailsForm.get('ddlDestinationCity').setValue(cell.destinationcitycode);
            this.rateDetailsForm.controls.ddlService.setValue(cell.servicename);
            this.ngxLoaderService.stop();
        }
    }

    updateRateDetails() {
        if (this.rateDetailsForm.valid) {
            const rateDetailsObj = {
                id: this.Id,
                origicountrycode: this.rateDetailsForm.get("ddlOriginCountry")?.value,
                originstatecode: this.rateDetailsForm.get("ddlOriginState")?.value,
                origincitycode: this.rateDetailsForm.get("ddlOriginCity")?.value,
                destinationcountrycode: this.rateDetailsForm.get("ddlDestinationCountry")?.value,
                destinationstatecode: this.rateDetailsForm.get("ddlDestinationState")?.value,
                destinationcitycode: this.rateDetailsForm.get("ddlDestinationCity")?.value,
                productcode: this.rateDetailsForm.get("ddlProduct")?.value,
                vendorcode: this.rateDetailsForm.get("ddlVendor")?.value,
                servicename: this.rateDetailsForm.get("ddlService")?.value,
                zonecode: this.rateDetailsForm.get("ddlZone")?.value,
                weight: this.rateDetailsForm.get("txtWeight")?.value,
                rate: this.rateDetailsForm.get("txtRate")?.value,
                ratetype: this.rateDetailsForm.get("ddlCategory")?.value
            }

            this.rateUploadService.UpdateRateInfoById(rateDetailsObj).subscribe(res => {
                try {
                    if (res && res.success) {
                        this.activeModal.close('Update RateDetails');
                    }
                } catch (error) {
                    console.error(error)
                }
            });
        }
    }

    async bindCountries(): Promise<void> {
        try {
            const observable = this.geoService.GetAllCountries();
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.countryList = res.data;
            }

        } catch (e) {
            console.error(e);
        }
    }

    onOriginCountryChange() {
        const countryCode: any = (this.countryList as any).filter((item: any) => item.code == this.rateDetailsForm.get('ddlOriginCountry').value)[0]?.isocode;
        if (countryCode) {
            this.rateDetailsForm.controls.ddlOriginState.reset();
            this.rateDetailsForm.controls.ddlOriginCity.reset();
            this.bindStatesByCountry(countryCode, 'origin');
        }
    }

    onDestinationCountryChange() {
        const countryCode: any = (this.countryList as any).filter((item: any) => item.code == this.rateDetailsForm.get('ddlDestinationCountry').value)[0]?.isocode;
        if (countryCode) {
            this.rateDetailsForm.controls.ddlDestinationState.reset();
            this.rateDetailsForm.controls.ddlDestinationCity.reset();
            this.bindStatesByCountry(countryCode, 'destination');
        }
    }

    async bindStatesByCountry(countryCode?: string, type?: any): Promise<void> {
        try {
          if (countryCode) {
            const observable = this.geoService.GetAllStates({ countrycode: countryCode });
            const res = await lastValueFrom(observable);
            if (res && res.success) {
              if (type === 'origin') {
                this.originStateList = res.data;
    
              } else {
                this.destinationStateList = res.data;
              }
            }
          }
        } catch (error) {
          console.error(error);
          throw error;
        }
      }

    onOriginStateChange() {
        const stateCode: any = (this.originStateList as any).filter((item: any) => item.code == this.rateDetailsForm.get('ddlOriginState').value)[0]?.isocode;
        // const countryCode = this.rateDetailsForm.get('ddlOriginState').value;
        if (stateCode) {
            this.rateDetailsForm.controls.ddlOriginCity.reset();
            this.bindCitiesByState(stateCode, 'origin');
        }
    }

    onDestinationStateChange() {
        const stateCode: any = (this.destinationStateList as any).filter((item: any) => item.code == this.rateDetailsForm.get('ddlDestinationState').value)[0]?.isocode;
        // const countryCode = this.rateDetailsForm.get('ddlDestinationState').value;
        if (stateCode) {
            this.rateDetailsForm.controls.ddlDestinationCity.reset();
            this.bindCitiesByState(stateCode, 'destination');
        }
    }

    async bindCitiesByState(stateCode?: string, type?: any): Promise<void> {
        try {
          if (stateCode) {
            const observable = this.geoService.GetAllCities({ statecode: stateCode });
            const res = await lastValueFrom(observable);
            if (res && res.success) {
              if (type === 'origin') {
                this.originCityList = res.data;
              } else {
                this.destinationCityList = res.data;
              }
            }
          }
        } catch (e) {
          console.error(e);
        }
      }

    getAllVendorServices(eventid?: any, vendorChanged?: any) {
        if (eventid) {
            const vendorcode = this.vendorList.filter((item: any) => item.code == eventid)[0]?.id;
            const vendorid = vendorcode ? vendorcode : eventid
            if (vendorChanged)
                this.rateDetailsForm.controls.ddlService.reset();
            try {
                this.vendorService.GetAllListByVendor({ id: vendorid }).subscribe((res) => {
                    if (res && res.success) {
                        this.serviceList = res.data;
                    }
                })
            } catch (error) {
            }
        }
    }

    async getAllProducts(): Promise<void> {
        try {
            const observable = this.productService.GetAll();
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.productList = res.data;
            }

        } catch (e) {
            console.error(e);
        }
    }

    async getAllVendors(): Promise<void> {
        try {
            const observable = this.vendorService.GetAll({ isactive: true });
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.vendorList = res.data;
            }

        } catch (e) {
            console.error(e);
        }
    }

    async getAllZones(): Promise<void> {
        try {
            const observable = this.zoneService.GetAll();
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.zoneList = res.data;
            }

        } catch (e) {
            console.error(e);
        }
    }
}